type ShortFieldObject = { getState: () => { isDirty: boolean } };
export const getChangedFieldNames = <FieldKey extends string = string>(
    fields: Record<FieldKey, ShortFieldObject>
): FieldKey[] =>
    (Object.entries(fields) as [FieldKey, ShortFieldObject][]).reduce<FieldKey[]>((acc, [name, field]) => {
        if (field.getState().isDirty) {
            acc.push(name);
        }

        return acc;
    }, []);
